import React, { useState } from "react";
import { Box } from "@mui/material";
import "./toggle.css";

import { ReactComponent as NightIcon } from "./night.svg";
import { ReactComponent as DayIcon } from "./day.svg";

export default function DNToggle({ defaultChecked,
    state, setState, onChange = (status) => { } }) {
    const [toggle, setToggle] = useState(localStorage.selectedTheme == "" ? true : false);

    const handleToggle = (event) => {
        if (event.target.checked) {
            document.body.classList.remove("dark")
            localStorage.selectedTheme = ""

        } else {
            document.body.classList.add("dark")
            localStorage.selectedTheme = "dark"
        }
        setToggle(event.checked)


    };

    return (
        <Box>
            <div className="theme-toggle" style={{ marginTop: '-3px' }}>
                <input
                    type="checkbox"
                    id="toggle"
                    checked={toggle}
                    onChange={handleToggle}
                />

                <label htmlFor="toggle" className="toggle-label">
                    <span className="icon sun" style={{ background: 'none' }}>
                        <DayIcon />
                    </span>
                    <span className="icon moon" style={{ background: 'none' }}>
                        <NightIcon />
                    </span>
                </label>
            </div>
        </Box>
    );
}